import Modal from '../../../Components/Overlays/Modal/Modal';
export default Modal;
